import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { faChartColumn, faTableCells } from '@fortawesome/free-solid-svg-icons';
import { FaIcon } from '../../common/FaIcon';

export type AnalyticsView = 'table' | 'chart';

interface Props {
  value: AnalyticsView;
  onChange: (next: AnalyticsView) => void;
}

export const AnalyticsViewToggle: FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();
  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={value}
      onChange={(_, next: AnalyticsView | null) => {
        if (next) onChange(next);
      }}
    >
      <ToggleButton value="chart">
        <FaIcon icon={faChartColumn} width={14} height={14} />
        <span style={{ marginLeft: '0.4rem' }}>{t('analytics.view.chart')}</span>
      </ToggleButton>
      <ToggleButton value="table">
        <FaIcon icon={faTableCells} width={14} height={14} />
        <span style={{ marginLeft: '0.4rem' }}>{t('analytics.view.table')}</span>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
